import { render, staticRenderFns } from "./FacebookStreamModal.vue?vue&type=template&id=252a555e&scoped=true&"
import script from "./FacebookStreamModal.vue?vue&type=script&lang=js&"
export * from "./FacebookStreamModal.vue?vue&type=script&lang=js&"
import style0 from "./FacebookStreamModal.vue?vue&type=style&index=0&id=252a555e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a555e",
  null
  
)

export default component.exports